
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/Matrix-MC2-LED-Grow-Light",
      function () {
        return require("private-next-pages/product/Matrix-MC2-LED-Grow-Light.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/Matrix-MC2-LED-Grow-Light"])
      });
    }
  